import { FormField } from '../../../../shared/models/form-builder/form-field.model';
export class FieldDesignChangeInfo {
    public saveDesignChange: boolean;
    public updatedFlexFieldSourceField: FormField;
}
